const CONTENT_GAP = 80;

const plansTable = document.querySelector(`.plansTable`);
const plansTableBody = plansTable.querySelector(`.plansTable__body`);
const plansTableHead = plansTable.querySelector(`.plansTable__head`);
const plansTableHeadWidth = plansTableHead.offsetWidth;

const devsOnScroll = () => {
  let fromTop = window.scrollY;

  // when table head is/becomes visible
  if (plansTable.offsetTop >= fromTop + CONTENT_GAP) {
    plansTableHead.classList.remove(`plansTable__head--fixed`);
    plansTableHead.style.removeProperty(`width`);
  }

  // when table head is hides
  if (plansTable.offsetTop < fromTop + CONTENT_GAP) {
    plansTableHead.style.width = `${plansTableHeadWidth}px`;
    plansTableHead.classList.add(`plansTable__head--fixed`);
  }

  // when scrolled to table bottom
  if (fromTop + CONTENT_GAP + plansTableHead.offsetHeight >= plansTableHead.offsetTop + plansTable.offsetHeight) {
    plansTableHead.style.top = `${(plansTable.offsetTop + plansTable.offsetHeight) - (fromTop + CONTENT_GAP + plansTableHead.offsetHeight)}px`;
  }

  // when start scrolling back to table top
  if (fromTop + CONTENT_GAP + plansTableHead.offsetHeight < plansTableHead.offsetTop + plansTable.offsetHeight) {
    plansTableHead.style.removeProperty(`top`);
  }
};

window.addEventListener(`scroll`, devsOnScroll);